<div id="showcase">
    <div id="showcaseCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
            <button type="button" data-bs-target="#showcaseCarousel" *ngFor="let slide of slider, let i = index"
                class="{{ (i == 0) ? 'active' : '' }}" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1"
                attr.data-bs-slide-to="{{i}}"></button>
        </div>
        <div class="carousel-inner">
            <div class="carousel-item" *ngFor="let slide of slider, let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
                <div class="container-fluid d-flex justify-content-center align-items-center" id="loader"
                    *ngIf="isLoading[i]">
                    <app-loader></app-loader>
                </div>
                <img [src]="slide.imgUrl" alt="Slider" class="img-fluid animate__animated animate__slideInRight w-100"
                    [ngStyle]="{visibility:isLoading[i]?'hidden':'visible'}" (load)="hideLoader(i)"
                    (error)="hideLoader(i)">
                <!-- <div class="carousel-caption d-none d-md-block" *ngIf="!isLoading[i]">
                    <h1>{{slide.title}}</h1>
                </div> -->
            </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>
</div>